var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"btn-wrapper",class:{'is-block': _vm.isBlock}},[_c('button',{class:[
      'btn',
      {'is-loading': _vm.isLoading},
      {'is-primary': _vm.primary},
      {'is-primary-invert': _vm.primaryInvert},
      {'is-secondary': _vm.secondary},
      {'is-tertiary': _vm.tertiary},
      {'has-tooltip': _vm.tooltip},
      {'has-icon': _vm.hasIcon},
      {'is-subtle': _vm.subtle},
      {'is-pulsing': _vm.pulse}
    ],attrs:{"disabled":_vm.isDisabled},on:{"click":_vm.click}},[(_vm.tooltip)?_c('Tooltip',{attrs:{"content":_vm.tooltip}}):_vm._e(),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.isLoading)?_c('img',{staticClass:"btn-loading",attrs:{"src":require('../assets/loading.svg')}}):_vm._e()]),_c('span',[_vm._t("default")],2)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }